import { render, staticRenderFns } from "./image-layer.vue?vue&type=template&id=8da349e4&scoped=true&"
import script from "./image-layer.vue?vue&type=script&lang=ts&"
export * from "./image-layer.vue?vue&type=script&lang=ts&"
import style0 from "./image-layer.vue?vue&type=style&index=0&id=8da349e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da349e4",
  null
  
)

export default component.exports